// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/settingsRoutes.test.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { WarholOutputSettings } from "./warholOutputSettingsRoute";

import { canEnterpriseAdmin, requiresAuth } from "../../../utils/auth";
import { authLayoutRoute } from "../../auth-layout/route";
import { ticketsRoute } from "../../tickets/route";

export const warholOutputGuidanceRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "output-guidance",
  beforeLoad() {
    requiresAuth();
    if (!canEnterpriseAdmin()) {
      throw redirect({ to: ticketsRoute.to } as never);
    }
  },
  component: WarholOutputSettings,
});
